export const PRODUCT_CATALOG = {
  "Solar Panel": [
    "100W Mono Solar Panel",
    "150W Mono Solar Panel",
    "200W Mono Solar Panel",
    "300W Mono Solar Panel",
    "400W Mono Solar Panel",
    "550W Bifacial Solar Panel",
  ],
  "Inverter": [
    "1.5kVA Pure Sine Wave Inverter",
    "2.5kVA Pure Sine Wave Inverter",
    "3.5kVA Hybrid Inverter",
    "5kVA Hybrid Inverter",
    "7.5kVA Hybrid Inverter",
    "10kVA Hybrid Inverter",
  ],
  "Battery": [
    "100Ah 12V Tubular Battery",
    "200Ah 12V Tubular Battery",
    "100Ah 12V Lithium Battery",
    "200Ah 12V Lithium Battery",
    "5kWh Lithium Wall Battery",
  ],
  "Charge Controller": [
    "30A PWM Charge Controller",
    "60A PWM Charge Controller",
    "40A MPPT Charge Controller",
    "60A MPPT Charge Controller",
    "100A MPPT Charge Controller",
  ],
  "Accessory": [
    "4mm Solar Cable (per metre)",
    "6mm Solar Cable (per metre)",
    "MC4 Connector Pair",
    "Solar Combiner Box",
    "Mounting Rail (per metre)",
    "Earthing Rod",
  ],
  "Street Light": [
    "30W All-in-One Solar Street Light",
    "60W All-in-One Solar Street Light",
    "100W Split Solar Street Light",
    "150W Split Solar Street Light",
    "200W Split Solar Street Light",
  ],
};

export const WAREHOUSES = [
  "Abuja",
  "Lagos",
  "Festac Office",
  "Uyo",
  "Port Harcourt",
  "Kano",
  "Asaba",
  "Ibadan",
];

export const PAYMENT_STAGES = [
  "1st payment",
  "2nd payment",
  "3rd payment",
  "4th payment",
  "Final payment",
];

export const STATUS_META = {
  pending_admin: { label: "Pending Admin Review", bg: "#FEF3C7", fg: "#92400E" },
  cancelled_by_admin: { label: "Returned to Sales", bg: "#FEE2E2", fg: "#B91C1C" },
  pending_finance: { label: "Awaiting Payment", bg: "#DBEAFE", fg: "#1E40AF" },
  payment_confirmed: { label: "Payment Confirmed", bg: "#DCFCE7", fg: "#166534" },
  awaiting_next_payment: { label: "Awaiting Next Payment", bg: "#F5D0FE", fg: "#86198F" },
  refund_pending: { label: "Refund Pending", bg: "#FEE2E2", fg: "#B91C1C" },
  in_warehouse: { label: "In Warehouse", bg: "#E0E7FF", fg: "#3730A3" },
  delivered: { label: "Delivered", bg: "#D1FAE5", fg: "#047857" },
  completed: { label: "Completed", bg: "#0F172A", fg: "#FFFFFF" },
  cancelled: { label: "Cancelled", bg: "#0F172A", fg: "#FCA5A5" },
};

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  sales: "Sales Rep",
  admin: "Admin",
  finance: "Finance",
  warehouse: "Warehouse",
};

export function formatMoney(n) {
  if (n == null || isNaN(n)) return "-";
  return "₦" + Number(n).toLocaleString(undefined, { maximumFractionDigits: 2 });
}

export function formatDateTime(s) {
  if (!s) return "-";
  const d = typeof s === "string" ? new Date(s) : s;
  return d.toLocaleString(undefined, {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function lineTotal(item) {
  const qty = Number(item.quantity) || 0;
  const unit = Number(item.unit_price) || 0;
  const truck = Number(item.truck_fee) || 0;
  return qty * (unit + truck);
}
